/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileCodeShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2v12h2V4h7v5h5v11H8v2h12V7.586L14.414 2zm12.586 5H15V5.414z" />
        <path d="M10.975 12.854 8.707 15.12l2.268 2.268-.707.707-2.975-2.975 2.975-2.975zm3-.708-.707.708 2.267 2.267-2.267 2.268.707.707 2.975-2.975zM1 16l1.474 1.474c-.573.66-.753 1.236-.753 1.236C.459 22.564 5.019 23 5.019 23c-2.609-1.67-1.942-2.876-.672-3.653L6 21v-5z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileCodeShortcut as FileCodeShortcut };
